import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Reveal } from '../motion/Reveal';
import { WORLD_CARDS, worldSrc } from '../../data/lumiTopics';

const LumiWorld = () => {
  const { t } = useTranslation();
  const { language } = useParams();
  const items = t('lumi.world.items', { returnObjects: true });
  const cards = Array.isArray(items) ? items : [];

  return (
    <section className="home-odam-section home-odam-section--soft lumi-world" id="lumi-world">
      <div className="container">
        <Reveal>
          <h2 className="home-odam-h2">{t('lumi.world.title')}</h2>
        </Reveal>
        <Reveal delay={0.06}>
          <p className="home-odam-lead">{t('lumi.world.subtitle')}</p>
        </Reveal>
        <div className="lumi-world__grid">
          {WORLD_CARDS.map((card, i) => {
            const item = cards[i] || {};
            const img = (
              <img
                src={worldSrc(card.image, language)}
                alt={item.alt || item.title || ''}
                width="600"
                height="600"
                loading="lazy"
                decoding="async"
              />
            );
            const body = (
              <>
                <div className="lumi-world__visual">{img}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </>
            );
            return (
              <Reveal key={card.image} delay={0.04 * i}>
                {card.href ? (
                  <Link className="lumi-world__card" to={`/${language}${card.href}`}>
                    {body}
                  </Link>
                ) : (
                  <article className="lumi-world__card">{body}</article>
                )}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LumiWorld;
